import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { JobDetailsV2Fragment} from 'graphql.generated';

import { Delta } from 'quill/core';
import { ActionSource } from 'src/app/state/action-sources';

import { SummaryType } from './job-create-summary.reducer';

export const JobSummaryActions = createActionGroup({
    source: ActionSource.SUMMARY_OVERVIEW,
    events: {
        'Summary Clicked': emptyProps(),
        'Job Summaries Loaded': props<{ job: JobDetailsV2Fragment }>(),
        'Summary Editor Content Changed': props<{
            key: SummaryType,
            delta: Delta,
        }>(),
        'Summary Tab Clicked': props<{
            summaryIndex: number;
        }>(),
    },
});
